const live_classes_pt = require('./live_classes.json')
export default live_classes_pt
